// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__3VGrP","heading":"styles_heading__1zBnH","progressbarDiv":"styles_progressbarDiv__3ujs8","circularProgress":"styles_circularProgress__1goGA"};